import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const UltraFiltrationUfPlants: React.FC = () => {
  return (
    <>
      <PageHeader title="Ultra Filtration (UF) Plants" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/uf.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Ultra Filtration (UF) Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Ultra Filtration (UF) is a membrane-based water treatment process that removes suspended solids, colloids, bacteria, viruses, and high-molecular-weight organics, ensuring high-quality water for further purification or direct use. At Wasser Technochem (India) Ltd., we offer robust and scalable UF systems of proven OEMs tailored to Indian industrial and municipal needs.</p>
              <p>UF is typically deployed either as a standalone treatment or as a pre-treatment for RO, EDI, or Demineralization systems, offering superior performance over conventional filtration methods like sand or carbon filters.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-filter text-primary me-2"></i>Pre-treatment for Reverse Osmosis (RO)</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Municipal drinking water purification</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Industrial process water production</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Wastewater recycling (polishing of treated effluent)</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Food & beverage and pharmaceutical-grade water</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Pretreatment in Zero Liquid Discharge (ZLD) systems</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL designs and implements both hollow-fiber and tubular-type UF plants, with system capacities ranging from 5 m³/hr to 500+ m³/hr.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-layer-group text-primary me-2"></i>UF Membrane Modules – PES, PVDF</h5>
                <p className="ms-4">Sourced from leading global OEMs; available in dead-end or crossflow configurations.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cube text-primary me-2"></i>Skid-Mounted / Containerized Units</h5>
                <p className="ms-4">Plug-and-play design with minimal civil requirements.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-sync-alt text-primary me-2"></i>Auto-Backwash, Air Scour & CIP Systems</h5>
                <p className="ms-4">For extended membrane life and reduced fouling.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-desktop text-primary me-2"></i>Integrated PLC/SCADA Automation</h5>
                <p className="ms-4">Enables real-time monitoring, diagnostics, and maintenance alerts.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Consistent water quality with &gt; 99% turbidity & bacteria removal</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>No chemical usage in filtration process</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact footprint, fully automated</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Extended membrane life and high recovery rates</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Proven UF installations across textile, cement, and power sectors</p>
              <p><i className="fa fa-star text-warning me-2"></i>UF Systems on City Sewage for Industrial use</p>
              <p><i className="fa fa-star text-warning me-2"></i>Local support for membrane replacement, servicing, and troubleshooting</p>
              <p><i className="fa fa-star text-warning me-2"></i>Expert design based on raw water treatability studies and pilots</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Integrated approach with RO, MBR, and ZLD systems</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UltraFiltrationUfPlants;
